// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap);"]);
// Module
exports.push([module.id, "tr.eos-meeting__todo-summary--empty-state:hover td[data-v-6c2156b0]{background-color:#fff}.eos-meeting__todo-summary__email[data-v-6c2156b0]{width:190px;white-space:nowrap}.eos-meeting__todo-summary__type[data-v-6c2156b0]{width:100px}.eos-meeting__todo-summary__tw-branding[data-v-6c2156b0]{font-size:14px}", ""]);
// Exports
module.exports = exports;
